import { render, staticRenderFns } from "./importModule.vue?vue&type=template&id=25446f72&scoped=true&"
import script from "./importModule.vue?vue&type=script&lang=js&"
export * from "./importModule.vue?vue&type=script&lang=js&"
import style0 from "./importModule.vue?vue&type=style&index=0&id=25446f72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25446f72",
  null
  
)

export default component.exports